let toastTimer;
let lastUploadSuccess = 0;

export const showFileUploadFeedback = (message, isUpload = false) => {
  if (isUpload) lastUploadSuccess = Date.now();

  let toast = document.getElementById("file-upload-feedback");
  if (!toast) {
    toast = document.createElement("div");
    toast.id = "file-upload-feedback";
    toast.setAttribute("role", "status");
    toast.setAttribute("aria-live", "polite");
    document.body.appendChild(toast);
  }

  toast.textContent = message;
  toast.style.cssText =
    "position:fixed;top:20px;right:20px;z-index:20000;max-width:360px;" +
    "padding:12px 18px;border-radius:6px;background:#198754;color:white;" +
    "box-shadow:0 4px 14px rgba(0,0,0,.2);font-size:14px;";
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => toast.remove(), 3500);
};

export const listenForFileSelection = () => {
  document.addEventListener("change", (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== "file" || !input.files?.length) return;

    const selectedAt = Date.now();
    setTimeout(() => {
      // A handler may clear an invalid selection or show a validation error.
      // Some form controls remount the input to display the accepted filename.
      if (!input.files?.length || lastUploadSuccess >= selectedAt) return;
      if (document.querySelector(".overlay-snack .error, .swal2-icon-error")) return;
      showFileUploadFeedback("File uploaded successfully");
    }, 300);
  }, true);
};
